import { HttpContextToken, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { LoadingService } from '@shared/services/loading.service'
import { Injectable, inject } from '@angular/core'
import { finalize } from 'rxjs'

export const SkipLoading = new HttpContextToken<boolean>(() => false)
export const GetForwardInterest = new HttpContextToken<boolean>(() => false)
export const GetPaymentProviderDetails = new HttpContextToken<boolean>(() => false)
export const GetPreauthTransactions = new HttpContextToken<boolean>(() => false)
export const GetTransactions = new HttpContextToken<boolean>(() => false)
export const GetTransactionsReport = new HttpContextToken<boolean>(() => false)
export const LoadingBankIdLink = new HttpContextToken<boolean>(() => false)
export const LoadingInvoices = new HttpContextToken<boolean>(() => false)
export const UpdatingCustomerDetails = new HttpContextToken<boolean>(() => false)

export enum LoadingContexts {
  getForwardInterest = 'getForwardInterest',
  getPaymentProviderDetails = 'getPaymentProviderDetails',
  getPreauthTransactions = 'getPreauthTransactions',
  getTransactions = 'getTransactions',
  getTransactionsReport = 'getTransactionsReport',
  loadingBankIdLink = 'loadingBankIdLink',
  loadingInvoices = 'ladingInvoices',
  updatingCustomerDetails = 'updatingCustomerDetails',
}

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService)
  private contexts = new Map<HttpContextToken<boolean>, LoadingContexts>([
    [GetForwardInterest, LoadingContexts.getForwardInterest],
    [GetPaymentProviderDetails, LoadingContexts.getPaymentProviderDetails],
    [GetPreauthTransactions, LoadingContexts.getPreauthTransactions],
    [GetTransactions, LoadingContexts.getTransactions],
    [GetTransactionsReport, LoadingContexts.getTransactionsReport],
    [LoadingBankIdLink, LoadingContexts.loadingBankIdLink],
    [LoadingInvoices, LoadingContexts.loadingInvoices],
    [UpdatingCustomerDetails, LoadingContexts.updatingCustomerDetails],
  ])

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    if (req.context.get(SkipLoading)) {
      return next.handle(req)
    }
    this.loadingService.on()
    for (const item of this.contexts.entries()) {
      if (req.context.has(item[0])) {
        this.loadingService.setActiveContext(item[1])
      }
    }
    return next.handle(req).pipe(
      finalize(() => {
        this.loadingService.off()
        for (const item of this.contexts.entries()) {
          if (req.context.has(item[0])) {
            this.loadingService.unsetActiveContext(item[1])
          }
        }
      }),
    )
  }
}
